import crypto from 'crypto';

import { TABLE_ASCII_CUSTOM } from '../../constants/encryption';

const encryption_secret = process.env.REACT_APP_ENCRYPTION_KEY || window.REACT_APP_ENCRYPTION_KEY;
const algorithm = 'aes-256-gcm';

const Encryption = {
  encrypt: (data) => {
    const iv = crypto.randomBytes(12);
    const key = crypto.createHash('sha256').update(encryption_secret).digest();

    const cipher = crypto.createCipheriv(algorithm, key, iv);
    const encrypted = Buffer.concat([cipher.update(JSON.stringify(data), 'utf8'), cipher.final()]);
    const tag = cipher.getAuthTag();

    return `${iv.toString('hex')}.${encrypted.toString('hex')}.${tag.toString('hex')}`;
  },

  decrypt: (encryption) => {
    const [encryptedIv, encryptation, tag] = encryption.split('.');
    const key = crypto.createHash('sha256').update(encryption_secret).digest();
    const iv = Buffer.from(encryptedIv, 'hex');
    const encryptedData = Buffer.from(encryptation, 'hex');
    const authTag = Buffer.from(tag, 'hex');

    const decipher = crypto.createDecipheriv(algorithm, key, iv);
    decipher.setAuthTag(authTag);

    const decrypted = Buffer.concat([decipher.update(encryptedData), decipher.final()]);
    return JSON.parse(decrypted.toString('utf8'));
  },
  encryptSimple: (text) => {
    const shift = (text.length % 10) + 3;
    let encryptedText = '';

    for (const mainChar of text) {
      let asciiValue = TABLE_ASCII_CUSTOM[mainChar] + shift;

      if (asciiValue > 125) {
        const diff = asciiValue - 125;
        asciiValue = 31 + diff;
      }

      for (const [key, value] of Object.entries(TABLE_ASCII_CUSTOM)) {
        if (asciiValue === value) {
          encryptedText += key;
          break;
        }
      }
    }

    return encryptedText;
  },
  decryptSimple: (encryptedText) => {
    const shift = (encryptedText.length % 10) + 3;
    let decryptedText = '';

    for (const mainChar of encryptedText) {
      let asciiValue = TABLE_ASCII_CUSTOM[mainChar] - shift;

      if (asciiValue < 32) {
        const diff = 32 - asciiValue;
        asciiValue = 126 - diff;
      }

      for (const [key, value] of Object.entries(TABLE_ASCII_CUSTOM)) {
        if (asciiValue === value) {
          decryptedText += key;
          break;
        }
      }
    }

    return decryptedText;
  },
};

export default Encryption;
